/** @jsxImportSource @emotion/react */

import PromosImageDefault from "assets/common/images/promos-default.png";
import { useState } from "react";
import { isMobile } from "router";

import PromotionDetail from "../PromotionDetail";
import { PromotionCardStyle } from "./index.style";

interface PromotionCardProps {
  name: string;
  image?: string;
  wager: string;
  content: string | TrustedHTML;
  isSubcribe: boolean;
  link?: string;
}

const PromotionCard = (props: PromotionCardProps) => {
  const { image, content, isSubcribe, link } = props;
  const [showContent, setShowContent] = useState<boolean>(false);

  const handleClickPromotion = () => {
    if (link) {
      window.open(link, "_blank")?.focus();
    } else {
      setShowContent((prev) => !prev);
    }
  };

  return (
    <div css={PromotionCardStyle.self}>
      <div css={PromotionCardStyle.thumbnail} onClick={handleClickPromotion}>
        <img
          src={image || PromosImageDefault}
          alt="prommos-thumbnail"
          onError={(e) => {
            (e.target as HTMLImageElement).src = PromosImageDefault;
          }}
        />
      </div>

      {!isMobile && (
        <PromotionDetail
          isOpen={showContent}
          isSubcribe={isSubcribe}
          content={content as TrustedHTML}
          onClose={() => setShowContent(false)}
        />
      )}
    </div>
  );
};

export default PromotionCard;
